import React from 'react'

import List from './List'
import Item from './Item'

const TagCloud = ({ words }) => (
	<List>
		{words.map(word => (
			<Item key={word.text} fontSize={word.size}>
				{word.text}
			</Item>
		))}
	</List>
)

export default TagCloud
